import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderCancelAndRefundUsingAmop,
  orderEligibilitiesMockEligibleToRefundUsingAmop,
  orderMockEligibleToRefundUsingAmop,
} from '../../../mock/data/index';

/**
 * Mocks for refundable order using payment method Paypal.
 */
export const eligibleToRefundUsingPaypalMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefundUsingAmop)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundUsingAmop)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundUsingAmop)]
};
